module.exports = __webpack_public_path__ + "img/2020_DSC_8697rv.9d85da71.jpg";